// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3cgUT","right":"styles_right__29Dx2"};